import { get, post } from '../../../../DAL/data-provider';
import { INotificationsResponse, NotificationAction } from '../notifications-interfaces';

export const getNotificationsData = async () : Promise<INotificationsResponse> => {
    return get('/api/notifications/data');
};

export const setNotificationsAction = async (userNTFGUID: string, actionID: NotificationAction) : Promise<INotificationsResponse> => {
    return post('/api/notifications/set', {
        userNTFGUID,
        actionID,
    });
};